import WisPetApp from "./Together_Ever";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./about";
import SciencePage from "./science";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<WisPetApp />} />
        <Route path="/about" element={<About />} />
        <Route path="/science" element={<SciencePage />} />
      </Routes>
    </BrowserRouter>
  );
}
